var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#C6D6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 27.6668C13.875 27.6668 13.4828 27.5038 13.1567 27.1777C12.8306 26.8516 12.6672 26.4591 12.6667 26.0002V16.0002C12.6667 15.5418 12.83 15.1496 13.1567 14.8235C13.4833 14.4974 13.8756 14.3341 14.3333 14.3335H19.3333L21 16.0002H27.6667C28.125 16.0002 28.5175 16.1635 28.8442 16.4902C29.1708 16.8168 29.3339 17.2091 29.3333 17.6668H14.3333V26.0002L16.3333 19.3335H30.5833L28.4375 26.4793C28.3264 26.8404 28.1217 27.1288 27.8233 27.3443C27.525 27.5599 27.195 27.6674 26.8333 27.6668H14.3333Z",
    fill: "#2E34D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBg);
export default __webpack_public_path__ + "static/media/folder-bg.8934f4ff3274fa7a74b47329c9d12589.svg";
export { ForwardRef as ReactComponent };